import React, { act, FC, useMemo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { AddRoleFormData } from "./validation.schema";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid2";
import DataTable, { createDataRow, HeadCell } from "@/components/DataTable";
import { useSearchActions } from "@/hooks/management/useActions.manage";
import { defaultFilters, Filters } from "@/ui/content/actions/Filters";
import { Checkbox, Typography } from "@mui/material";
import DataTableFilters from "@/ui/content/roles/Filters";

type TabRoleActionsProps = {
  editMode?: boolean;
};

export const TabRoleActions: FC<TabRoleActionsProps> = ({
  editMode = false,
}) => {
  const { t: tCommon } = useTranslation("common");
  const { t } = useTranslation("roles");

  const {
    control,
    watch,
    formState: { errors },
    getValues,
    setValue,
  } = useFormContext<AddRoleFormData>();
  const [filters, setFilters] = useState<Filters>(defaultFilters);

  const {
    actionsResponse,
    isLoadingActions,
    isFetchingActions,
    refetchActions,
  } = useSearchActions({
    sortField: filters.sortField,
    sortOrder: filters.sortOrder,
    pageNumber: filters.pageNumber,
    pageSize: filters.pageSize,
    search: filters.search,
  });
  const actions = watch("actions");

  const rows = useMemo(() => {
    console.log("actionsResponse", actionsResponse);
    if (!actionsResponse || (actionsResponse?.actions || []).length === 0)
      return [];
    const myActions = (actions as string[]) || [];
    return actionsResponse.actions.map((item, index) => {
      const row = createDataRow(index, {
        check: (
          <Checkbox
            checked={myActions.some((idAction) => item._id === idAction)}
            onChange={(e) => {
              const currentValue = getValues("actions") as string[];
              let newValue;
              if (e.target.checked) {
                newValue = [...currentValue, item._id];
              } else {
                newValue = (currentValue || []).filter((it) => it !== item._id);
              }
              setValue("actions", newValue);
            }}
          />
        ),
        name: <div>{`${item.name}`}</div>,
        description: <div>{item.description}</div>,
      });
      return row;
    });
  }, [actionsResponse, actions]);

  const headCells: HeadCell[] = [
    {
      id: "check",
      isSortable: true,
      disablePadding: false,
      label: "",
      align: "left",
      width: "20px",
    },
    {
      id: "name",
      isSortable: true,
      disablePadding: false,
      label: t("header.action-name"),
      align: "left",
      width: "30%",
    },
    {
      id: "description",
      isSortable: true,
      disablePadding: false,
      label: t("header.description"),
      align: "left",
      width: "65%",
    },
  ];

  return (
    <Grid container spacing={"20px"}>
      <Grid size={12}>
        <DataTableFilters
          filtersState={[filters, setFilters]}
          placeHolder={t("place-holders.search-actions")}
        />
        <DataTable
          data={rows}
          headCells={headCells}
          isLoading={isLoadingActions || isFetchingActions}
          order={filters.sortOrder === 1 ? "asc" : "desc"}
          orderBy={filters.sortField}
          rowsPerPage={filters.pageSize}
          page={filters.pageNumber}
          total={actionsResponse?.totalCount}
          onChangePage={(event, newPage) => {
            setFilters((filters) => ({
              ...filters,
              pageNumber: newPage,
            }));
          }}
          onChangeSize={(event) => {
            setFilters((filters) => ({
              ...filters,
              pageNumber: 0,
              pageSize: Number(event.target.value),
            }));
          }}
          onChangeSort={(order, orderBy) => {
            setFilters((filters) => ({
              ...filters,
              pageNumber: 0,
              sortField: orderBy as string,
              sortOrder: order === "asc" ? 1 : -1,
            }));
          }}
          maxHeight={400}
        />
      </Grid>
      <Grid size={12}>
        {errors.actions && (
          <Typography color="error" variant="body2">
            {errors.actions.message ||
              tCommon("validations.validator_min_items", { count: 1 })}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};
